import React from 'react'

const ImportFichiers = () => {
  return (
    <div>ImportFichiers</div>
  )
}

export default ImportFichiers